import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest } from '../../../../../../../src/app/ncs/models/actor/actor';




@Component({
  selector: 'follicularscanstcindi',
  templateUrl: './follicularscanstcindi.component.html',
  styleUrls: ['./follicularscanstcindi.component.scss']
})

export class FollicularscansTCIndiPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public EndometriumThickness: number;
  public LeftOvaries: number;
  public RightOvaries: number;
  public MedicineName: string;
  public TestName: string;
  public TestName1: string;
  public Owner: string;
  public FormattedCode: string;
  public Protocolst: string;
  public ProtocolEd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string;
  public CycleNo: string;
  public Sign1: string;
  public Sign2: string;
  public CycleType: string;
  public EggSourceType: string;
  public DSADOC: string;
  public DSASTIMULATION: string;
  public DSAANTAG: string;
  public GradingModel: string;
  public TcModel: string;
  //public ActorID: any;
  public Date: Date;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: string;
  NextScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public Doc: string;
  public DocDate: string;
  public AFCCount: string;
  public FollicularGowthcodeData: any;
  public EggSourceData: string;
  public DonorData: string;
  public DonorCode: string;

  CurrentFollicularScanDetailController: FollicularScanDetailController[];
  ScanDetail: FollicularScanDetailController;
  CurrentFollicularScanDetailRequest: FollicularScanDetailRequest;
  ScanCode: any;
  CycleCode: any;
  PatientCode: any;
  ActivityCode: any;
  PickUpCode: any;
  // this.ScanCode = this.route.snapshot.paramMap.get('ScanCodeData');
  //this.CycleCode = this.route.snapshot.paramMap.get('CycleCode');
  //this.PatientCode = this.route.snapshot.paramMap.get('PatientCode');
  //this.ActivityCode = this.route.snapshot.paramMap.get('CycleActivity');


  LoadScansData() {
    //alert("ScansData")
    this.CurrentFollicularScanDetailRequest = new FollicularScanDetailRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentFollicularScanDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.FollicularGowthcodeData = this.route.snapshot.paramMap.get('FollicularGowthcodeData');
    this.CycleCode = this.route.snapshot.paramMap.get('CycleCode');
    this.PatientCode = this.route.snapshot.paramMap.get('PatientCode');
    //this.ActivityCode = this.route.snapshot.paramMap.get('CycleActivity');

    this.CurrentFollicularScanDetailRequest.ScanCode = this.FollicularGowthcodeData;
    this.CurrentFollicularScanDetailRequest.CycleCode = this.CycleCode;
    this.CurrentFollicularScanDetailRequest.PatientCode = this.PatientCode;

    this.GetFollicularScanDetailController();
  }

  GetFollicularScanDetailController() {
    this.StartRefreshing();


    //this.CurrentFollicularScanDetailRequest.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
    //this.CurrentFollicularScanDetailRequest.PatientCode = this.SelectedpatientDetails.PatientCode;

    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScanDetailController(this.CurrentFollicularScanDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScanDetailController = this.ApiResData.Result;
          this.EndometriumThickness = this.CurrentFollicularScanDetailController[0].EndometriumThickness;
          this.Sign1 = this.CurrentFollicularScanDetailController[0].Sign1;
          this.Sign2 = this.CurrentFollicularScanDetailController[0].Sign2;
          this.ScanDetail = this.CurrentFollicularScanDetailController[0];

          if (this.ScanDetail.NextDocDate != null) {
            var SValidFrom = new Date(this.ScanDetail.NextDocDate);
            if (SValidFrom.getFullYear() > 1900) {
              console.log('this.UpdateDate >1990');
              this.NextScanDate = {

                year: SValidFrom.getFullYear(),
                month: SValidFrom.getMonth() + 1,
                day: SValidFrom.getDate()
              }
            }
          }
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadMedicineData();

          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
  CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;
  hasMedicine: boolean=false;
  LoadMedicineData() {
    //alert("ScansData")
    this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CycleCode = this.route.snapshot.paramMap.get('CycleCode');
    this.ActivityCode = this.route.snapshot.paramMap.get('CycleActivity');

    this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleMedicineByCodeController();
  }

  GetIvfCycleMedicineByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.ActivityCode;
    this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
    this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;
          //alert(this.ApiResData.Result.length)
          if (this.ApiResData.Result.length != 0) {
            this.hasMedicine = true;
          }
          //this.MedicineName = this.CurrentIvfCycleMedicineByCodeController[1].MedicineName;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadTestData();

          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
  CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;
  hasTest: boolean = false;
  LoadTestData() {
    //alert("ScansData")
    this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CycleCode = this.route.snapshot.paramMap.get('CycleCode');
    this.ActivityCode = this.route.snapshot.paramMap.get('CycleActivity');
    this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleTestByCodeController();
  }

  GetIvfCycleTestByCodeController() {
    this.StartRefreshing();

    //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
    this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
    //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
    this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.ActivityCode;
    this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
    this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;

    //alert(this.FormattedCode);
    this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;
          if (this.ApiResData.Result.length != 0) {
            this.hasTest = true;
          }
          //this.TestName = this.CurrentIvfCycleTestByCodeController[0].TestName;
          //this.TestName1 = this.CurrentIvfCycleTestByCodeController[1].TestName;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadOvaryData();


          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentFollicularScanOvaryDetailController: FollicularScanOvaryDetailController[];
  CurrentFollicularScanOvaryDetailRequest: FollicularScanOvaryDetailRequest;

  LoadOvaryData() {
    //alert("ScansData")
    this.CurrentFollicularScanOvaryDetailRequest = new FollicularScanOvaryDetailRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.FollicularGowthcodeData = this.route.snapshot.paramMap.get('FollicularGowthcodeData');
    this.CycleCode = this.route.snapshot.paramMap.get('CycleCode');
    this.PatientCode = this.route.snapshot.paramMap.get('PatientCode');
    this.CurrentFollicularScanOvaryDetailRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularScanOvaryDetailController();
  }

  GetFollicularScanOvaryDetailController() {
    this.StartRefreshing();

    this.CurrentFollicularScanOvaryDetailRequest.ScanCode = this.FollicularGowthcodeData;
    this.CurrentFollicularScanOvaryDetailRequest.CycleCode = this.CycleCode;
    this.CurrentFollicularScanOvaryDetailRequest.PatientCode = this.PatientCode;

    //alert(this.FormattedCode);
    this.actorservice.GetFollicularScanOvaryDetailController(this.CurrentFollicularScanOvaryDetailRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularScanOvaryDetailController = this.ApiResData.Result;
          this.AFCCount = this.CurrentFollicularScanOvaryDetailController[0].AFCCount;
          //this.LeftOvaries = this.CurrentFollicularScanOvaryDetailController[5].Size;
          //this.RightOvaries = this.CurrentFollicularScanOvaryDetailController[1].Size;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadOvariesData();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //LoadPrintData() {
  //  this.printService.onDataReady();
  //}
  CurrentFollicularPickUpsByCodeController: FollicularPickUpsByCodeController[];
  //FollicularPickupEndInfo: FollicularPickUpsByCodeController;
  CurrentFollicularPickUpsByCodeRequest: FollicularPickUpsByCodeRequest;

  LoadOvariesData() {
    //alert("ScansData")
    this.CurrentFollicularPickUpsByCodeRequest = new FollicularPickUpsByCodeRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.PickUpCode = this.route.snapshot.paramMap.get('PickupCodeData');
    this.CurrentFollicularPickUpsByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFollicularPickUpsByCodeController();
  }

  GetFollicularPickUpsByCodeController() {
    this.StartRefreshing();
    this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.PickUpCode;
    //this.CurrentFollicularPickUpsByCodeRequest.IvfCycleFolliculePickupCode = this.SelectedpatientDetails.PickUpCode;
    //this.CurrentFollicularPickUpsDetailRequest.CycleActivity = this.SelectedpatientDetails.PickUpCycleActivity;
    //this.CurrentFollicularPickUpsDetailRequest.TreatmentCycle = this.SelectedpatientDetails.PickUpTreatmentCycle;
    //this.CurrentFollicularPickUpsDetailRequest.FollicularPickup = this.SelectedpatientDetails.PickUpCode;
    //this.CurrentFollicularPickUpsDetailRequest.OvumPlannedPickupDate = this.SelectedpatientDetails.OvumPlannedPickupDate;
    //this.CurrentFollicularPickUpsDetailRequest.ActorCode = this.SelectedpatientDetails.ActorCode;
    //alert(this.FormattedCode);
    this.actorservice.GetFollicularPickUpsByCodeController(this.CurrentFollicularPickUpsByCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentFollicularPickUpsByCodeController = this.ApiResData.Result;
          //this.FollicularPickupEndInfo = this.CurrentFollicularPickUpsByCodeController[0];
          //if (this.FollicularPickupEndInfo.OvulationTriggerDate != null) {
          //  var SValidFrom = new Date(this.FollicularPickupEndInfo.OvulationTriggerDate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.OvulationTriggerDate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //if (this.FollicularPickupEndInfo.OvumPickupdate != null) {
          //  var SValidFrom = new Date(this.FollicularPickupEndInfo.OvumPickupdate);
          //  if (SValidFrom.getFullYear() > 1900) {
          //    console.log('this.UpdateDate >1990');
          //    this.OvumPickupdate = {

          //      year: SValidFrom.getFullYear(),
          //      month: SValidFrom.getMonth() + 1,
          //      day: SValidFrom.getDate()
          //    }
          //  }
          //}
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.printService.onDataReady()
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //pdata: any[];
  //onDataReady() {
  //  setTimeout(() => {
  //    window.print();
  //    this.isPrinting = true;
  //    this.router.navigate([{ outlets: { print: null } }]);
  //  });
  //}
  //isPrinting = false;


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp" );
    this.Date = new Date();

    this.Doc = this.route.snapshot.paramMap.get('Doc');
    this.DocDate = this.route.snapshot.paramMap.get('DocDate');
    this.ScanDate = this.route.snapshot.paramMap.get('ScanDate');
    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.FormattedCode = this.route.snapshot.paramMap.get('FormattedCode');
    this.Protocolst = this.route.snapshot.paramMap.get('Protocolst');
    this.ProtocolEd = this.route.snapshot.paramMap.get('ProtocolEd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    //this.ActorID = this.route.snapshot.paramMap.get('ActorID');
    this.DSADOC = this.route.snapshot.paramMap.get('DSADOC');
    this.DSASTIMULATION = this.route.snapshot.paramMap.get('DSASTIMULATION');
    this.DSAANTAG = this.route.snapshot.paramMap.get('DSAANTAG');
    this.GradingModel = this.route.snapshot.paramMap.get('GradingModelData');
    this.TcModel = this.route.snapshot.paramMap.get('TcModelData');
    this.FollicularGowthcodeData = this.route.snapshot.paramMap.get('FollicularGowthcodeData');
    this.EggSourceData = this.route.snapshot.paramMap.get('EggSourceData');
    this.DonorData = this.route.snapshot.paramMap.get('DonorData');
    this.DonorCode = this.route.snapshot.paramMap.get('DonorCode');
    this.LoadScansData();

  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








